
import React from 'react';
import { File, Search } from 'lucide-react';

interface EmptyStateDocumentsProps {
  isFilteredEmpty: boolean;
  hasDocuments: boolean;
}

const EmptyStateDocuments: React.FC<EmptyStateDocumentsProps> = ({
  isFilteredEmpty,
  hasDocuments,
}) => {
  if (!hasDocuments) {
    return (
      <div className="border rounded-lg p-8 text-center">
        <File className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-lg font-medium text-gray-900">No documents</h3>
        <p className="mt-1 text-gray-500">
          Upload documents for the company to get started.
        </p>
      </div>
    );
  }
  
  if (isFilteredEmpty) {
    return (
      <div className="border rounded-lg p-8 text-center">
        <Search className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-lg font-medium text-gray-900">No matching documents</h3>
        <p className="mt-1 text-gray-500">
          Try adjusting your search or filters to find documents.
        </p>
      </div>
    );
  }
  
  return null;
};

export default EmptyStateDocuments;
